import getSymbolFromCurrency from 'currency-symbol-map'
import { Flo } from '../../types/flo-auth-api'
import ProductItem from './productItem'

export const toProductItemRef = (i) => `ProductItem-${i}`

export const createProductItems = (productsList: Flo.Offers.OffersList) => {
  return productsList.map((item, i) => {
    const period = `${item?.period}ly`
    const priceData = item?.price?.[period]
    const price = `${priceData?.amount / priceData?.scale}`
    return {
      ref: toProductItemRef(i),
      productItemId: i,
      type: ProductItem,
      label: item?.name,
      price: `at ${getSymbolFromCurrency(priceData.currency)}${price}/${item?.period}`,
      productId: item?.id,
      period,
    }
  })
}
